
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';
import SanityBlockContentExpandable from '~/components/Sanity/SanityBlockContentExpandable.vue';
import GalaLogoIcon from '~/components/SvgIcons/GalaLogoIcon.vue';

@Component({
  components: {
    GalaLogoIcon,
    SanityBlockContentExpandable,
  },
})
export default class ProjectUpdate extends Vue {
  @Prop(Object) readonly doc!: ISanityDocuments[SanityDocumentSchema.ARTICLE];
  @Prop(Object)
  readonly relatedDoc!: ISanityDocuments[SanityDocumentSchema.PROJECT];
  @Prop(Number) readonly counter!: number;

  schemas = SanityDocumentSchema;
  showMore = false;

  get avatarUrl() {
    if (!this.relatedDoc?.avatar?.asset?._ref) {
      return '';
    }
    return this.$sanityImage
      .urlFor(this.relatedDoc.avatar)
      .width(48)
      .height(48)
      .url();
  }
}
